// config/i18n/index.ts
import './i18n';
console.log('✅ i18n loaded!');
export {}; // để không bị tree-shaken
